import { render, staticRenderFns } from "./CheckLists.vue?vue&type=template&id=071c387d&"
import script from "./CheckLists.vue?vue&type=script&lang=js&"
export * from "./CheckLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports